var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"px-2"},[_c('h1',{staticClass:"h5"},[(_vm.icon)?_c('fa-icon',{staticClass:"icon fa-fw",attrs:{"icon":_vm.icon,"size":"sm"}}):_vm._e(),_vm._v(_vm._s(_vm.title)+" ")],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }